import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50/50 pb-20">
      {/* ================= PREMIUM CATEGORY BANNER ================= */}
      <div className="bg-gradient-to-br from-[#2d006b] to-[#4600a3] text-white py-6 md:py-8 mb-6 relative overflow-hidden shadow-inner">
        {/* Subtle Background Patterns */}
        <div className="absolute inset-0 opacity-10 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMCwwLDAsMC4wNSkiLz48L3N2Zz4=')]" />
        <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 animate-pulse" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-red opacity-10 rounded-full blur-2xl translate-y-1/3 -translate-x-1/4" />
        
        <div className="max-w-7xl mx-auto px-4 relative z-10 flex flex-col items-center text-center">
          <span className="text-purple-200 text-xs md:text-sm font-bold tracking-[0.2em] uppercase mb-1">कानूनी जानकारी</span>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-black capitalize tracking-tight mb-3 drop-shadow-md">
             नियम और शर्तें
          </h1>
          <div className="w-12 h-1 bg-gradient-to-r from-purple-200 to-white rounded-full opacity-90 shadow-[0_0_15px_rgba(255,255,255,0.5)]" />
        </div>
      </div>

      {/* CONTENT */}
      <div className="max-w-4xl mx-auto px-4 py-10">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 text-gray-700 leading-relaxed space-y-8">
          
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. शर्तों की स्वीकृति</h2>
            <p>
              मंदाकिनी टाइम्स में आपका स्वागत है। हमारी वेबसाइट तक पहुँचने और उसका उपयोग करके, आप इस समझौते की शर्तों और प्रावधानों को स्वीकार करते हैं और उनसे बाध्य होने के लिए सहमत होते हैं। यदि आप इन शर्तों का पालन करने के लिए सहमत नहीं हैं, तो कृपया इस वेबसाइट का उपयोग न करें।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. बौद्धिक संपदा अधिकार</h2>
            <p>
              हमारी साइट पर प्रकाशित और उपलब्ध कराई गई सभी सामग्री मंदाकिनी टाइम्स और साइट के रचनाकारों की संपत्ति है। इसमें चित्र, पाठ, लोगो, दस्तावेज़, डाउनलोड करने योग्य फ़ाइलें और हमारी साइट की संरचना में योगदान देने वाली कोई भी चीज़ शामिल है, लेकिन इन्हीं तक सीमित नहीं है।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. उपयोगकर्ता योगदान</h2>
            <p>
              उपयोगकर्ता तब तक टिप्पणियां और अन्य सामग्री पोस्ट कर सकते हैं जब तक कि सामग्री अवैध, अश्लील, धमकी भरी, मानहानिकारक, बौद्धिक संपदा अधिकारों का उल्लंघन करने वाली, या अन्यथा तीसरे पक्ष के लिए हानिकारक न हो। मंदाकिनी टाइम्स के पास ऐसी सामग्री को हटाने या संपादित करने का अधिकार सुरक्षित है।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. समाचार और जानकारी की सटीकता</h2>
            <p>
              हालांकि हम सटीक, अप-टू-डेट पत्रकारिता प्रदान करने का प्रयास करते हैं, मंदाकिनी टाइम्स इस जानकारी की पूर्णता, विश्वसनीयता या सटीकता की गारंटी नहीं देता है। इस वेबसाइट पर आपको मिलने वाली जानकारी पर आपके द्वारा की जाने वाली कोई भी कार्रवाई पूरी तरह से आपके अपने जोखिम पर है।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. तृतीय-पक्ष लिंक</h2>
            <p>
              हमारी वेबसाइट में तृतीय-पक्ष वेबसाइटों या सेवाओं के लिंक हो सकते हैं जो मंदाकिनी टाइम्स के स्वामित्व या नियंत्रण में नहीं हैं। हमारा कोई नियंत्रण नहीं है, और किसी भी तृतीय-पक्ष वेबसाइट की सामग्री, गोपनीयता नीतियों, या प्रथाओं के लिए कोई जिम्मेदारी नहीं लेते हैं।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. इन शर्तों में परिवर्तन</h2>
            <p>
              हम किसी भी समय इन शर्तों को संशोधित करने का अधिकार सुरक्षित रखते हैं। हम ऐसा साइट पर पोस्ट करके और अद्यतन शर्तों की ओर ध्यान आकर्षित करके करेंगे। ऐसे परिवर्तन किए जाने के बाद साइट पर जाने और उसका उपयोग जारी रखने का आपका निर्णय नए नियमों और शर्तों की आपकी औपचारिक स्वीकृति है।
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. हमसे संपर्क करें</h2>
            <p>
              यदि इन शर्तों के बारे में आपके कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें:
            </p>
            <ul className="mt-2 list-disc list-inside text-purple-600 font-medium">
              <li>Email: info@mandakinitimes.com</li>
              <li>Phone: +91 97557 24915</li>
            </ul>
          </section>
          
        </div>
      </div>
    </div>
  );
};

export default Terms;
